// AUTO-GENERATED (gen_toolspage_i18n.py). Free-tools gallery page, 22 languages.
export const TOOLS_GEN = {
 "fr": {
  "navLabel": "Outils gratuits",
  "h1": "Outils gratuits pour éleveurs",
  "title": "Outils gratuits pour éleveurs et fermiers | Ma Petite Ferme",
  "meta": "Calculateurs gratuits pour éleveurs : coût de l'œuf, rentabilité du poulailler, date d'éclosion, quantité d'aliment et taille de poulailler.",
  "intro": "Des calculateurs gratuits pour piloter votre élevage au quotidien. Utilisez-les en ligne ou intégrez-les gratuitement sur votre site."
 },
 "it": {
  "navLabel": "Strumenti gratuiti",
  "h1": "Strumenti gratuiti per allevatori",
  "title": "Strumenti gratuiti per allevatori e contadini | Ma Petite Ferme",
  "meta": "Calcolatori gratuiti per allevatori: costo delle uova, redditività del pollaio, data di schiusa, quantità di mangime e dimensioni del pollaio.",
  "intro": "Calcolatori gratuiti per gestire il tuo allevamento ogni giorno. Usali online oppure integrali gratuitamente sul tuo sito."
 },
 "en": {
  "navLabel": "Free Tools",
  "h1": "Free Tools for Farmers and Homesteaders",
  "title": "Free Tools for Farmers and Homesteaders | Ma Petite Ferme",
  "meta": "Free calculators for poultry keepers: egg cost, chicken coop profitability, hatch date, feed quantity, and coop size.",
  "intro": "Free calculators to help you manage your flock and farm every day. Use them online or embed them for free on your own website."
 },
 "es": {
  "navLabel": "Herramientas gratuitas",
  "h1": "Herramientas gratuitas para criadores",
  "title": "Herramientas gratuitas para criadores y granjeros | Ma Petite Ferme",
  "meta": "Calculadoras gratuitas para criadores: costo del huevo, rentabilidad del gallinero, fecha de eclosión, cantidad de alimento y tamaño del gallinero.",
  "intro": "Calculadoras gratuitas para gestionar tu granja día a día. Úsalas en línea o inclúyelas gratuitamente en tu sitio web."
 },
 "sv": {
  "navLabel": "Gratis verktyg",
  "h1": "Gratis verktyg för djuruppfödare",
  "title": "Gratis verktyg för djuruppfödare och lantbrukare | Ma Petite Ferme",
  "meta": "Gratis kalkylatorer för uppfödare: äggets kostnad, hönshusets lönsamhet, kläckningsdatum, fodermängd och hönshus storlek.",
  "intro": "Gratis kalkylatorer för att sköta din uppfödning i vardagen. Använd dem online eller integrera dem kostnadsfritt på din webbplats."
 },
 "nl": {
  "navLabel": "Gratis tools",
  "h1": "Gratis tools voor pluimveehouders",
  "title": "Gratis tools voor pluimveehouders en boeren | Ma Petite Ferme",
  "meta": "Gratis calculators voor pluimveehouders: kostprijs per ei, rendabiliteit kippenhok, uitkomstdatum, voederhoeveelheid en kippenhokvgrootte.",
  "intro": "Gratis calculators om uw kweek dagelijks te beheren. Gebruik ze online of integreer ze gratis op uw website."
 },
 "de": {
  "navLabel": "Kostenlose Tools",
  "h1": "Kostenlose Tools für Tierhalter",
  "title": "Kostenlose Tools für Tierhalter und Landwirte | Ma Petite Ferme",
  "meta": "Kostenlose Rechner für Tierhalter: Ei-Kosten, Rentabilität des Hühnerstalls, Schlupfdatum, Futtermenge und Stallgröße.",
  "intro": "Kostenlose Rechner für die tägliche Verwaltung Ihrer Tierhaltung. Nutzen Sie sie online oder binden Sie sie kostenlos auf Ihrer Website ein."
 },
 "da": {
  "navLabel": "Gratis værktøjer",
  "h1": "Gratis værktøjer til landmænd",
  "title": "Gratis værktøjer til fjerkræavlere og landmænd | Ma Petite Ferme",
  "meta": "Gratis beregnere til landmænd: ægpris, hønsegårdens rentabilitet, klækningsdato, fodermængde og hønsegårdens størrelse.",
  "intro": "Gratis beregnere til den daglige drift af dit landbrug. Brug dem online eller integrer dem gratis på din hjemmeside."
 },
 "bg": {
  "navLabel": "Безплатни инструменти",
  "h1": "Безплатни инструменти за животновъди",
  "title": "Безплатни инструменти за животновъди и фермери | Ma Petite Ferme",
  "meta": "Безплатни калкулатори за животновъди: цена на яйце, рентабилност на кокошарник, дата на излюпване, количество храна и размер на кокошарник.",
  "intro": "Безплатни калкулатори за ежедневно управление на вашето животновъдство. Използвайте ги онлайн или ги интегрирайте безплатно в своя уебсайт."
 },
 "hr": {
  "navLabel": "Besplatni alati",
  "h1": "Besplatni alati za uzgajivače",
  "title": "Besplatni alati za uzgajivače i farmere | Ma Petite Ferme",
  "meta": "Besplatni kalkulatori za uzgajivače: cijena jajeta, isplativost kokošinjca, datum izlijeganja, količina hrane i veličina kokošinjca.",
  "intro": "Besplatni kalkulatori za svakodnevno upravljanje vašim uzgojem. Koristite ih online ili ih besplatno ugradite na svoju web stranicu."
 },
 "et": {
  "navLabel": "Tasuta tööriistad",
  "h1": "Tasuta tööriistad loomakasvatajatele",
  "title": "Tasuta tööriistad loomakasvatajatele ja talunikele | Ma Petite Ferme",
  "meta": "Tasuta kalkulaatorid loomakasvatajatele: muna omahind, kanala tasuvus, koorumiskuupäev, söödakogus ja kanala suurus.",
  "intro": "Tasuta kalkulaatorid oma karja igapäevaseks juhtimiseks. Kasuta neid veebis või integreeri tasuta oma veebisaidile."
 },
 "fi": {
  "navLabel": "Ilmaiset työkalut",
  "h1": "Ilmaiset työkalut kasvattajille",
  "title": "Ilmaiset työkalut kasvattajille ja maanviljelijöille | Ma Petite Ferme",
  "meta": "Ilmaiset laskurit kasvattajille: munan hinta, kanalan kannattavuus, kuoriutumispäivä, rehun määrä ja kanalan koko.",
  "intro": "Ilmaiset laskurit kotieläinkasvattajan arjen tueksi. Käytä niitä verkossa tai liitä ne ilmaiseksi omalle sivustollesi."
 },
 "el": {
  "navLabel": "Δωρεάν εργαλεία",
  "h1": "Δωρεάν εργαλεία για κτηνοτρόφους",
  "title": "Δωρεάν εργαλεία για κτηνοτρόφους και αγρότες | Ma Petite Ferme",
  "meta": "Δωρεάν υπολογιστές για κτηνοτρόφους: κόστος αυγού, αποδοτικότητα κοτετσιού, ημερομηνία εκκόλαψης, ποσότητα τροφής και μέγεθος κοτετσιού.",
  "intro": "Δωρεάν υπολογιστές για την καθημερινή διαχείριση της εκτροφής σας. Χρησιμοποιήστε τους online ή ενσωματώστε τους δωρεάν στον ιστότοπό σας."
 },
 "pt": {
  "navLabel": "Ferramentas gratuitas",
  "h1": "Ferramentas gratuitas para criadores",
  "title": "Ferramentas gratuitas para criadores e agricultores | Ma Petite Ferme",
  "meta": "Calculadoras gratuitas para criadores: custo do ovo, rentabilidade do galinheiro, data de eclosão, quantidade de ração e tamanho do galinheiro.",
  "intro": "Calculadoras gratuitas para gerir a sua criação no dia a dia. Use-as online ou incorpore-as gratuitamente no seu site."
 },
 "lv": {
  "navLabel": "Bezmaksas rīki",
  "h1": "Bezmaksas rīki lopkopjiem",
  "title": "Bezmaksas rīki lopkopjiem un lauksaimniekiem | Ma Petite Ferme",
  "meta": "Bezmaksas kalkulatori lopkopjiem: olas izmaksas, vistas mājas rentabilitāte, izšķilšanās datums, barības daudzums un vistas mājas izmērs.",
  "intro": "Bezmaksas kalkulatori ikdienas saimniecības vadībai. Izmantojiet tos tiešsaistē vai integrējiet savā vietnē bez maksas."
 },
 "pl": {
  "navLabel": "Darmowe narzędzia",
  "h1": "Darmowe narzędzia dla hodowców",
  "title": "Darmowe narzędzia dla hodowców i rolników | Ma Petite Ferme",
  "meta": "Darmowe kalkulatory dla hodowców: koszt jajka, rentowność kurnika, data wylęgu, ilość paszy i wielkość kurnika.",
  "intro": "Darmowe kalkulatory do codziennego zarządzania hodowlą. Korzystaj z nich online lub zintegruj bezpłatnie ze swoją stroną."
 },
 "lt": {
  "navLabel": "Nemokami įrankiai",
  "h1": "Nemokami įrankiai ūkininkams",
  "title": "Nemokami įrankiai ir skaičiuoklės ūkininkams | Ma Petite Ferme",
  "meta": "Nemokamos skaičiuoklės ūkininkams: kiaušinio savikaina, vištidės pelningumas, perėjimo data, pašaro kiekis ir vištidės dydis.",
  "intro": "Nemokamos skaičiuoklės kasdieniam ūkio valdymui. Naudokite jas internete arba integruokite nemokamai į savo svetainę."
 },
 "ro": {
  "navLabel": "Instrumente gratuite",
  "h1": "Instrumente gratuite pentru crescători",
  "title": "Instrumente gratuite pentru crescători și fermieri | Ma Petite Ferme",
  "meta": "Calculatoare gratuite pentru crescători: costul oului, rentabilitatea cotetului, data ecloziunii, cantitatea de hrană și dimensiunea cotetului.",
  "intro": "Calculatoare gratuite pentru a-ți gestiona ferma zi de zi. Folosește-le online sau integrează-le gratuit pe site-ul tău."
 },
 "hu": {
  "navLabel": "Ingyenes eszközök",
  "h1": "Ingyenes eszközök állattartóknak",
  "title": "Ingyenes eszközök és kalkulátorok állattartóknak | Ma Petite Ferme",
  "meta": "Ingyenes kalkulátorok állattartóknak: tojásköltség, csirkeól jövedelmezősége, kelési dátum, takarmánymennyiség és ólméret számítása.",
  "intro": "Ingyenes kalkulátorok a mindennapos állattartás megkönnyítéséhez. Használd őket online, vagy integráld őket ingyenesen a saját weboldaladra."
 },
 "sk": {
  "navLabel": "Bezplatné nástroje",
  "h1": "Bezplatné nástroje pre chovateľov",
  "title": "Bezplatné nástroje pre chovateľov a farmárov | Ma Petite Ferme",
  "meta": "Bezplatné kalkulačky pre chovateľov: náklady na vajce, rentabilita kurína, dátum vyliahnutia, množstvo krmiva a veľkosť kurína.",
  "intro": "Bezplatné kalkulačky na každodenné riadenie vášho chovu. Používajte ich online alebo ich zadarmo vložte na svoju webovú stránku."
 },
 "cs": {
  "navLabel": "Bezplatné nástroje",
  "h1": "Bezplatné nástroje pro chovatele",
  "title": "Bezplatné nástroje pro chovatele a farmáře | Ma Petite Ferme",
  "meta": "Bezplatné kalkulačky pro chovatele: cena vejce, výnosnost kurníku, datum líhnutí, množství krmiva a velikost kurníku.",
  "intro": "Bezplatné kalkulačky pro každodenní řízení vašeho chovu. Používejte je online nebo je zdarma vložte na své webové stránky."
 },
 "sl": {
  "navLabel": "Brezplačna orodja",
  "h1": "Brezplačna orodja za rejce",
  "title": "Brezplačna orodja za rejce in kmete | Ma Petite Ferme",
  "meta": "Brezplačni kalkulatorji za rejce: strošek jajca, donosnost kokošnjaka, datum izvalitve, količina krme in velikost kokošnjaka.",
  "intro": "Brezplačni kalkulatorji za vsakodnevno upravljanje vaše reje. Uporabljajte jih online ali jih brezplačno vstavite na svojo spletno stran."
 }
};
